import React from "react"

import DesktopMenu from "./deskTopMenu"
import MobileMenu from "./mobileMenu"

import './menu.css'

import logo from './../../image/logo.png'

const MenuList = [
    [
        'Home', // title
        '/', // Link
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-1 mx-1 pr-5' // Class for Mobile
    ],
    [
        'Whitepaper',
        'https://shibapup.dog/WhitePaper.pdf',
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-1 mx-1 pr-5' // Class for Mobile
    ],
    [
        'Tokenomics',
        '/#tokenomics',
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-1 mx-1 pr-5' // Class for Mobile
    ],
    [
        'Features',
        '/#features',
        'Global---menu-link px-3 py-1 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-1 mx-1 pr-5' // Class for Mobile
    ],
    [
        'Play to Earn',
        '/dashboard',
        'Global---menu-nav-btn px-5 py-2 btn',
        'Global---menu-nav-btn px-5 py-2 btn mx-2'
    ],
];
const Menu = () => {
    return(
        <div>
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        </div>
    )
}

export default Menu;